export default __webpack_public_path__ + "tsf0734ec.svg";